/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-12 08:59:15
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUICRUDTypeSpecial,
    IUITagInput,
    IUITagResult,
    UITag,
} from "../core";

type IUICRUDType = IUICRUDTypeSpecial["CRUDType"];
// @uiCRUDType - for iv-form-table, provide the CRUD type.
@UITag.set()
export class uiCRUDType extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object];
    allowNullRule: boolean = false;

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        const rule = this.parseRule(input);
        if (rule == null) return null;

        const otherMetaMap = input.metas.otherMetaMap;
        /// translate the string into real type.
        let specials: IUITagResult["specials"] = {
            CRUDType: Object.keys(rule).reduce((final, key) => {
                const typeName = rule[key];
                final[key] = otherMetaMap[typeName] ?? null;
                return final;
            }, {}),
        };

        /// normal case
        return { specials };
    }
}
